module.exports = __webpack_public_path__ + "img/flamingo.be5030ca.webp";